import React from 'react'

const MyButton = ({ heading, span }) => {
    return (
        <div className='text-center text-[#2E3D62] text-[35px] sm:text-[40px] leading-[52px] sm:leading-normal font-bold'>{heading} <span className='text-[#CB0B0B]'>{span}</span></div>
    )
}

export default MyButton